document.addEventListener("DOMContentLoaded", function () {
  const wishlistTitle = document.querySelector("h3[data-mywishlisttitle]");
  if (wishlistTitle) {
    const clonedNode = wishlistTitle.cloneNode(true); // Clone with content
    clonedNode.textContent = 'My Wishlist';
    wishlistTitle.parentNode.insertBefore(
      clonedNode,
      wishlistTitle.nextSibling
    ); // Insert after original
  }
});
